export const changeEnv = () => { let envValue = localStorage.getItem('ENV'); return (envValue ? envValue : "preproduction") }